/* eslint-disable react-hooks/exhaustive-deps */

import { Grid, Paper } from "@material-ui/core";
import { InputTextMaster, MasterButton } from "App/Component/ui";

import React, { useEffect } from "react";
import { useSearchHistorySep } from "./../hooks";
import { jenisPelayananName } from "./../helpers";
import { defaultDateDisplay, isNull } from "App/utils/helpers";
function TabHistory({ noBpjs }) {
  const { disabled, handleChange, handleSubmit, filter, rows, setNewData } =
    useSearchHistorySep(noBpjs);

  useEffect(() => {
    setNewData();
  }, []);

  return (
    <Paper
      className='show-element'
      style={{
        padding: "1rem",
      }}>
      <Grid container spacing={1}>
        <Grid item sm={4}>
          <InputTextMaster
            name='no_bpjs'
            label='NO BPJS'
            id='no_bpjs'
            value={filter.no_bpjs}
            placeholder={"No BPJS"}
            onChange={handleChange("no_bpjs")}
          />
        </Grid>
        <Grid item sm={4}>
          <InputTextMaster
            name='valid_from'
            label='TANGGAL MULAI'
            id='valid_from'
            type='date'
            autoFocus={true}
            value={filter.valid_from}
            onChange={handleChange("valid_from")}
          />
        </Grid>
        <Grid item sm={4}>
          <InputTextMaster
            name='valid_to'
            label='TANGGAL SELESAI'
            id='valid_to'
            type='date'
            autoFocus={true}
            value={filter.valid_to}
            onChange={handleChange("valid_to")}
          />
        </Grid>
      </Grid>
      <Grid
        container
        direction='row'
        justifyContent='flex-end'
        alignItems='center'>
        <MasterButton
          className={"mt-1"}
          type='button'
          onClick={(e) => handleSubmit(e)}
          color={disabled.color}
          name={disabled.label}
          size='md'
        />
      </Grid>

      <div
        className='custom-scrollbar mt-1'
        style={{
          maxHeight: "220px",
          overflow: "auto",
        }}>
        {rows.map((item, index) => {
          return <CardHistorySEP key={index} item={item} />;
        })}
      </div>
    </Paper>
  );
}

const CardHistorySEP = ({ item }) => {
  return (
    <div
      style={{
        backgroundColor: "#fff",
        padding: "1rem",
        borderRadius: 8,
        marginBottom: "0.5rem",
      }}>
      <p
        style={{
          fontSize: "18px",
          fontWeight: "600",
        }}>
        {item.noSep}
      </p>
      <p
        style={{
          fontSize: "12px",
          fontWeight: "500",
          letterSpacing: "5",
        }}>
        {jenisPelayananName(item.jnsPelayanan)}
      </p>
      <table
        style={{
          width: "90%",
          marginTop: "0.2rem",
          fontSize: "10px",
        }}>
        <tbody>
          <tr>
            <td>Tgl SEP</td>
            <td width='5%'>:</td>
            <td>{defaultDateDisplay(item.tglSep, false)}</td>
          </tr>
          <tr>
            <td>Tgl Pulang</td>
            <td width='5%'>:</td>
            <td>
              {isNull(item.tglPlgSep)
                ? ""
                : defaultDateDisplay(item.tglPlgSep, false)}
            </td>
          </tr>
          <tr>
            <td>PPK</td>
            <td width='5%'>:</td>
            <td>{item.ppkPelayanan}</td>
          </tr>
          <tr>
            <td>Diagnosa</td>
            <td width='5%'>:</td>
            <td>{item.diagnosa}</td>
          </tr>
          <tr>
            <td>Poliklinik</td>
            <td width='5%'>:</td>
            <td>{item.poli}</td>
          </tr>
          <tr>
            <td>Kelas</td>
            <td width='5%'>:</td>
            <td>{item.kelasRawat}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default TabHistory;
